module.exports = __webpack_public_path__ + "static/img/kffw-ban.673aa69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kffw-ban.jpg
// module id = lqxT
// module chunks = 1